import React from 'react'
import { Table, useMediaSize } from '@ally/metronome-ui'
import AccountGroup from '../../Shared/AccountGroup'
import AccountCard from '../../Shared/AccountCard'
import { getColumns } from '../TableColumns'
import MobileInvestAccountList from '../../Shared/MobileAccountsCard/MobileInvestAccountList'
import AccountCardMbox from '../../Shared/AccountCardMbox'
import {
  hasStaleAccounts,
  isAccountClosed,
  sortInvestAccountsGroup,
} from '../../utils'
import { NonPrintingWrapper } from '../../Shared/NonPrintingWrapper'
import { useCustomizeDashboard } from '../../CustomizeDashboard/CustomizeDashboardContext/CustomizeDashboardContext'
import { useAccountTypes } from '../../AccountTypeContext'

const SelfDirected: React.FC = props => {
  const [{ dashboardView }] = useCustomizeDashboard()
  const { isInvestOutage, investAccounts } = useAccountTypes()
  const invsAccountsGroup = investAccounts.filter(
    account => account.type === 'INVS',
  )
  const sortedInvsAccounts = sortInvestAccountsGroup(invsAccountsGroup)
  const allClosedAccounts = invsAccountsGroup.every(isAccountClosed)
  const isLgDown = useMediaSize('LgDown')
  const isMdDown = useMediaSize('MdDown')
  const isPrint = window.matchMedia('print').matches

  const hasStaleData = hasStaleAccounts(investAccounts)

  return (
    <>
      {sortedInvsAccounts.length && !isInvestOutage ? (
        <AccountGroup name="self-directed">
          <AccountCard type="INV" allClosedAccounts={allClosedAccounts}>
            {isMdDown && !isPrint ? (
              <MobileInvestAccountList
                accounts={sortedInvsAccounts}
                allClosedAccounts={allClosedAccounts}
                hasStaleData={hasStaleData}
              />
            ) : (
              <Table
                data={sortedInvsAccounts}
                columns={getColumns({
                  tableType: 'self-directed',
                  allClosedAccounts,
                  tableTypeHeader: 'Self-Directed',
                  view: dashboardView,
                  isLgDown,
                  hasStaleData,
                })}
                captionText="Information about your Ally Self-Directed Investment accounts"
                fullWidth
                suppressMdDownLayout
                withFooter={!allClosedAccounts}
              />
            )}
            <NonPrintingWrapper>
              <AccountCardMbox name="ally-dashboard-self-well" />
            </NonPrintingWrapper>
          </AccountCard>
        </AccountGroup>
      ) : null}
    </>
  )
}

export default SelfDirected
